import { gql } from "@apollo/client";
import { UserApplication } from "../types";
import { UserApplicationSessionEvent, userApplicationSessionEventFragment } from "../fragments";

export const GET_RECENT_USER_APPLICATION_SESSION_EVENTS = gql`
  query GetRecentUserApplicationSessionEvents(
    $application: user_application_enum!
    $itemId: uuid!
    $since: timestamptz!
  ) {
    userApplicationSessionEvents: user_application_session_event(
      where: { application: { _eq: $application }, item_id: { _eq: $itemId }, created_at: { _gte: $since } }
      order_by: { created_at: asc }
    ) {
      ...userApplicationSessionEventFragment
    }
  }
  ${userApplicationSessionEventFragment}
`;

export interface GetRecentUserApplicationSessionEventsData {
  userApplicationSessionEvents: UserApplicationSessionEvent[];
}

export interface GetRecentUserApplicationSessionEventsVars {
  application: UserApplication;
  itemId: string;
  since: string;
}
